import {Component, Inject, Optional, ChangeDetectionStrategy} from "@angular/core";

import {FormsModule} from "@angular/forms";
import {NzModalModule, NzModalRef, NzModalService} from "ng-zorro-antd/modal";
import {NzInputModule} from "ng-zorro-antd/input";
import {NzButtonModule} from "ng-zorro-antd/button";
import {NzFormModule} from "ng-zorro-antd/form";
import {NzDividerModule} from "ng-zorro-antd/divider";
import {InputBoxData} from "src/models/input-box-data";
@Component({
    selector: "app-input-box-modal",
    standalone: true,
    imports: [FormsModule, NzModalModule, NzInputModule, NzButtonModule, NzFormModule, NzDividerModule],
    template: `
        <div nz-row [nzJustify]="'center'" [nzGutter]="[0, 16]">
            <div nz-col [nzSpan]="24">
                <form #frm="ngForm" (ngSubmit)="onSave()" nz-form [nzLayout]="'vertical'">
                    <nz-form-item>
                        <nz-form-label [nzRequired]="'true'">{{ data?.placeholder || "Name" }}</nz-form-label>
                        <nz-form-control [nzErrorTip]="'Field is required'">
                            <input
                                nz-input
                                [(ngModel)]="name"
                                [ngModelOptions]="{standalone: true}"
                                [placeholder]="data?.placeholder || 'Enter name'"
                                [maxlength]="data?.maxLength || 50"
                                required
                                autocomplete="off" />
                        </nz-form-control>
                    </nz-form-item>
                </form>
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: [``]
})
export class InputBoxModalComponent {
    name = "";
    data: InputBoxData | null = null;
    constructor(@Optional() private modalRef: NzModalRef) {}
    onSave = () => {
        if (this.name.trim()) {
            this.modalRef.close(this.name.trim());
        }
    };
    onCancel(): void {
        this.modalRef.triggerCancel();
    }
}
